import { styled } from '@mui/material/styles';

export const Spinner = styled('circle')(({ theme }) => ({
  stroke: theme.palette.primary.light,
}));
